import translations from './de.json';
import { language } from './locale';

export { language } from './locale';

export function translate(text, locale = language) {
  if (locale !== 'de' || typeof text !== 'string') return text;
  const key = text.trim().replace(/\s+/g, ' ');
  const translated = translations[key];
  if (translated === undefined) return text;
  return `${/^\s/.test(text) ? ' ' : ''}${translated}${/\s$/.test(text) ? ' ' : ''}`;
}

export const t = translate;

export function setDocumentLanguage() {
  document.documentElement.lang = language;
  if (language === 'de') {
    document.querySelector('meta[name="description"]')?.setAttribute('content',
      'Ein Ort aus Leidenschaft für Automobile: professionelle Fahrzeugpflege, Detailing und Werkstattservice. Soft99 Garage. Made in Japan.');
  }
}
